import { render, staticRenderFns } from "./DetalheDocumentosFornecedorDadosGerais.vue?vue&type=template&id=868e8332"
import script from "./DetalheDocumentosFornecedorDadosGerais.vue?vue&type=script&lang=js"
export * from "./DetalheDocumentosFornecedorDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports